export default [
    {
        path: '/colors',
        name: 'colors',
        component: () =>
            import(/* webpackChunkName: "colors" */ '@/views/colors/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Cores', to: { name: 'colors' }, disable: true },
            ],
            whitelabel: true,
        },
    },
]
